import { memo } from 'react';
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import FormNumberField from 'components/ui/form/FormNumberField';
import FormCurrencyField from 'components/ui/form/FormCurrencyField';
import FormSimpleSelectField from 'components/ui/form/FormSimpleSelectField';
import CurrencyFormat from 'components/ui/text-formats/CurrencyFormat';

const CalculatorForPrint = ({ calculations, formik }) => {
  const { t } = useTranslation();

  return (
    <div className='calls-history-drawer-wrapper p-2 !w-full'>
      <div className='drawer-body'>
        <Grid
          container
          spacing={{ xs: 2, sm: 3, lg: 3 }}
          rowSpacing={1}
          columns={{ xs: 12, sm: 12, lg: 12 }}
        >
          <Grid item={true} lg={6} sm={6} xs={12}>
            <FormSimpleSelectField
              delay={0}
              label={t('common.fields.creditCalculationType')}
              fieldName='type'
              options={[
                { name: 'Annuitet (teng to‘lovli kredit)', id: 'annuitet' },
                {
                  name: 'Differensial (kamayib boruvchi to‘lovli kredit)',
                  id: 'differensial',
                },
              ]}
              formik={formik}
            />
          </Grid>
          <Grid item={true} lg={6} sm={6} xs={12}>
            <FormCurrencyField
              delay={0.1}
              label={t('common.filter.totalPrice')}
              fieldName='amount'
              formik={formik}
            />
          </Grid>

          <Grid item={true} lg={6} sm={6} xs={12}>
            <FormNumberField
              delay={0.2}
              label={t('common.fields.month')}
              fieldName='months'
              formik={formik}
            />
          </Grid>
          <Grid item={true} lg={6} sm={6} xs={12}>
            <FormCurrencyField
              delay={0.3}
              label={t('common.fields.percent')}
              fieldName='percent'
              formik={formik}
            />
          </Grid>
        </Grid>
      </div>
      <div className='mt-2 p-2 bg-gray-100 flex justify-between rounded-lg gap-2'>
        <div className='bg-gray-50 p-2 rounded-md grow'>
          <div>{t('payment.add.contract.totalSum')}</div>
          <span className='text-green-600'>
            <CurrencyFormat value={calculations?.totalPayment} suffix='' />
          </span>
        </div>
        <div className='bg-gray-50 p-2 rounded-md grow'>
          <div>{t('common.fields.overpayment')}</div>
          <span className='text-green-600'>
            <CurrencyFormat value={calculations?.overpayment} suffix='' />
          </span>
        </div>
      </div>

      <div className='calls-history-tab-item mt-2'>
        <TableContainer
          className='tab-table-container !shadow-none !base-border h-full'
          component='div'
        >
          <Table stickyHeader component='div'>
            <TableHead component='div'>
              <TableRow component='div'>
                <TableCell className='!bg-gray-50' component='div'>
                  {t('shaxmatka.homeDetail.monthlyPay')}
                </TableCell>
                <TableCell className='!bg-gray-50' component='div'>
                  {t('common.table.principal')}
                </TableCell>
                <TableCell className='!bg-gray-50' component='div'>
                  {t('common.table.interest')}
                </TableCell>
              </TableRow>
            </TableHead>
            {calculations?.schedule?.length > 0 ? (
              <TableBody className='overflow-hidden !bg-white' component='div'>
                <TableRow hover tabIndex={-1} key={'row-'}>
                  <TableCell size='small' component='div'>
                    <CurrencyFormat
                      value={Number(calculations?.schedule?.[0]?.payment)}
                      decimalScale={2}
                      suffix=''
                    />
                  </TableCell>
                  <TableCell size='small' component='div'>
                    <CurrencyFormat
                      value={Number(calculations?.schedule?.[0]?.principal)}
                      decimalScale={2}
                      suffix=''
                    />
                  </TableCell>
                  <TableCell size='small' component='div'>
                    <CurrencyFormat
                      value={Number(calculations?.schedule?.[0]?.interest)}
                      decimalScale={2}
                      suffix=''
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <TableBody component='div'>
                <TableRow component='div'>
                  <TableCell colSpan={6}>
                    <span className='text-gray-400 flex items-center justify-center'>
                      <i className='bi bi-exclamation-octagon text-xl leading-4 mr-1' />{' '}
                      {t('common.global.noDataFound')}
                    </span>
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};
export default memo(CalculatorForPrint);
